<template>
  <!-- 柏瑞康书斋 -->
  <div class="index-container">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <div class="index-content">
      <div class="condition-box">
        <div class="left-select">
          <div
            class="s-list"
            @click="changeSelect(item,index)"
            v-for="(item,index) in majorList"
            :key="'key' + index"
            :class="index === keyIndex?'list-active':''"
          >{{item.title}}</div>
        </div>
        <div class="right-tab-box">
          <div
            class="r-tab"
            :class="tabIndex === index ? 'tab-active' : ''"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabSelect(item, index)"
          >{{ item }}</div>
        </div>
      </div>
      <div class="commodity-content">
        <div
          class="commodity-list"
          v-for="(item,index) in commodityList"
          :key="index"
          @click="goCommodityDetail(item, index)"
        >
          <div class="c-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.thumb + ')' }"></div>
          <div class="c-title">{{item.title}}</div>
          <div class="c-price">
            ¥
            <span>{{item.price}}</span>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="page_size"
        :total="listTotal"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'studyRoom',
  components: {
    bannerImg
  },
  data() {
    return {
      imgUrl: imgUrl,
      bannerText: '大健康人才教育培训',
      keyIndex: 0,
      tabList: ['热门推荐', '价格高低', '最新上线', '销量'],
      tabIndex: 0,
      commodityList: [],
      listTotal: 0,
      majorList: [],
      cate_uuid: '',
      recommend: '',
      price: 'desc',
      new: '',
      sale: '',
      page_index: 1,
      page_size: 16
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    this.getGoodCate();
    this.getRoomList();
  },
  methods: {
    // 关键词选择
    changeSelect(item, index) {
      this.keyIndex = index;
      this.cate_uuid = item.uuid;
      this.getRoomList();
    },
    // 热门推荐选择
    tabSelect(item, index) {
      console.log(item, index);
      this.tabIndex = index;
      if (index == 0) {
        this.recommend = 1;
        this.price = '';
        this.new = '';
        this.sale = '';
      } else if (index == 1) {
        this.recommend = '';
        this.price = 'asc';
        this.new = '';
        this.sale = '';
      } else if (index == 2) {
        this.recommend = '';
        this.price = '';
        this.new = 1;
        this.sale = '';
      } else {
        this.recommend = '';
        this.price = '';
        this.new = '';
        this.sale = 'asc';
      }
      this.getRoomList();
    },
    // 跳转商品详情
    goCommodityDetail(item, index) {
      console.log(item);
      this.$router.push({ path: 'commodityDetail', query: { id: item.uuid } });
    },
    // 获取专业分类
    getGoodCate() {
      api.getGoodCate().then(res => {
        this.majorList = res.result;
      });
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getRoomList();
    },
    // 获取列表
    getRoomList() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        cate_uuid: this.cate_uuid,
        recommend: this.recommend,
        price: this.price,
        new: this.new,
        sale: this.sale
      };
      api.getRoomList(params).then(res => {
        console.log(res);
        this.commodityList = res.result.data;
        this.listTotal = res.result.total;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-conatiner {
  margin-top: 122PX;
  min-height: 600PX;
}
.index-content {
  width: 72%;
  padding-bottom: 80PX;
  margin: 0 auto;
}
.condition-box {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 50PX 0 36PX;
  .left-select {
    display: flex;
    flex-wrap: wrap;
    margin-right: 30PX;
  }
  .s-list {
    // width: 60PX;
    padding: 0 10PX;
    margin-right: 12PX;
    margin-bottom: 10PX;
    font-size: 16PX;
    color: #343434;
    line-height: 36PX;
    text-align: center;
    background-color: transparent;
    border-radius: 7PX;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background-color: #f6ab2b;
    }
  }
  .list-active {
    color: #ffffff;
    background-color: #f6ab2b;
  }
}
.right-tab-box {
  display: flex;
  flex-shrink: 0;
  border-radius: 18PX;
  .r-tab {
    width: 100PX;
    color: #333333;
    line-height: 36PX;
    text-align: center;
    border: 1PX solid #d6d6d6;
    cursor: pointer;
    &:first-child {
      border: 1PX solid #d6d6d6;
      border-right: none;
      border-top-left-radius: 18PX;
      border-bottom-left-radius: 18PX;
    }
    &:nth-child(2) {
      border-right: none;
    }
    &:last-child {
      border: 1PX solid #d6d6d6;
      border-left: none;
      border-top-right-radius: 18PX;
      border-bottom-right-radius: 18PX;
    }
    &:hover {
      color: #ffffff;
      border-color: #f6ab2b;
      background-color: #f6ab2b;
    }
  }
  .tab-active {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.commodity-content {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 60PX;
  .commodity-list {
    width: calc((100% - 90PX) / 4);
    padding: 25PX;
    margin: 0 30PX 58PX 0;
    cursor: pointer;
    &:hover {
      box-shadow: 0PX 3PX 15PX 1PX rgba(200, 200, 200, 0.35);
      .c-title {
        color: #ff7b1f;
      }
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .c-img {
    width: 100%;
    height: 208PX;
    background-color: wheat;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .c-title {
    padding: 22PX 0 14PX;
    font-size: 16PX;
    color: #3f3f3f;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .c-price {
    color: #ff7b1f;
    span {
      font-size: 26PX;
    }
  }
}

/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/studyRoom.vue